import { Injectable } from "@angular/core";
import { Adapter } from "src/app/adapter";
import * as moment from "moment";

export class UserMaster {
  constructor(
    public id: number,
    public userID: string,
    public name: string,
    public password: string,
    public department: string,
    public title: string,
    public birthday: moment.Moment,
    public anniversary: moment.Moment,
    public hireDate: moment.Moment,
    public poReqAprLimit: number,
    public poReqApproverID: number,
    public emailAddress: string,
    public defaultOutQ: string,
    public changeID: string,
    public lastUpdated: moment.Moment
  ) {}
}

@Injectable({
  providedIn: "root"
})
export class UserMasterAdapter implements Adapter<UserMaster> {
  adapt(item: any): UserMaster {
    return new UserMaster(
      item.URROWID,
      item.URUSERID,
      item.URNAME,
      item.URPASSWORD,
      item.URDEPARTMENT,
      item.URTITLE,
      item.URBIRTHDAY,
      item.URANNIVERSARY,
      item.URHIREDATE,
      item.URPOREQAPRLIMIT,
      item.URPOREQAPPROVERID,
      item.UREMAILADDRESS,
      item.URDEFAULTOUTQ,
      item.URCHANGEID,
      item.URLASTUPDATED
    );
  }
}
